import { createStore, applyMiddleware, compose } from 'redux';
import reduxLogger from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';

import rootReducer from '../reducers/index';
import client from '../graphql/client';

export default function configureStore(initialState) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const store = createStore(rootReducer, /* preloadedState, */ composeEnhancers(
        applyMiddleware(
            thunkMiddleware,
            reduxLogger,
            routerMiddleware(browserHistory),
            client.middleware(),
        ),
        applyMiddleware(
        )
    ));
    return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js